import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from '../models/app-config.model';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppConfig {
    static settings: IAppConfig;
    jsonFile: string = "";

    constructor(private http: HttpClient) { }
    load() {
        if (environment.name == "dev")
            this.jsonFile =`/Style Library/SCAServicesDeploy/assets/config/config.${environment.name}.json`;
            // this.jsonFile = `./assets/config/config.${environment.name}.json`;
        else
            this.jsonFile =`/Style Library/SCAServicesDeploy/assets/config/config.${environment.name}.json`;
            // this.jsonFile = `./assets/config/config.${environment.name}.json`;

        return new Promise<void>((resolve, reject) => {
            this.http.get(this.jsonFile).toPromise().then((response: IAppConfig) => {
                AppConfig.settings = <IAppConfig>response;
                resolve();
            }).catch((response: any) => {
                reject(`Could not load file '${this.jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}
